import Vue from "vue";
import App from "@/App.vue";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";
import * as constants from "@/constants";
import firebase from "firebase/app";
import "firebase/auth";

Vue.config.productionTip = false;

import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Vuetify from "vuetify/lib";
import { Touch } from 'vuetify/lib/directives'
Vue.use(Vuetify, {
  directives: {
    Touch
  }
});

// tiptap-vuetify plugin
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";

// Require dependencies for Cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
VueCookies.config("100000d");

// load vuex i18n module
import vuexI18n from "vuex-i18n";
Vue.use(vuexI18n.plugin, store);
// pre-load language objects
import { translationsEn } from "@/localization/translationsEn";
import { translationsSl } from "@/localization/translationsSl";
// add translations
Vue.i18n.add("en", translationsEn);
Vue.i18n.add("sl", translationsSl);

import moment from "moment";
moment.locale("sl");
// eslint-disable-next-line
import momentDurationFormatSetup from "moment-duration-format";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment
      .unix(value)
      .format(store.state.storeClient.client.environmentSettings.dateFormat);
  }
});
Vue.filter("formatDate2", function (value) {
  if (value) {
    return moment
      .unix(value)
      .format(store.state.storeClient.client.environmentSettings.dateFormat);
  }
});
Vue.filter("formatDate3", function (value) {
  if (typeof value === "string" || value instanceof String) {
    return moment(value).format(
      store.state.storeClient.client.environmentSettings.dateFormat
    );
  } else if (value.seconds > 0) {
    return moment
      .unix(value.seconds)
      .format(store.state.storeClient.client.environmentSettings.dateFormat);
  } else
    return moment(value).format(
      store.state.storeClient.client.environmentSettings.dateFormat
    );
});

// MIXINS
Vue.mixin({
  data() {
    return {
      currentAlignText: 1,
      currentTextBrush: 0,
      fonts: [
        "Bangers",
        "Staatliches",
        "Roboto Mono",
        "Oregano",
        "Rum Raisin",
        "Amatic SC",
        "Ranchers",
        "Parisienne",
        "Itim",
        "Eater"
      ],
      textBrushes: [
        {
          // zelen z belo obrobo
          fontText: 4,
          shadowText: 8,
          shadowTextColor: "#FFFFFF",
          textColor: "#026915FF",
          textColorBackground: "#82fc9800"
        },
        {
          // rdeč na prozorni črni
          fontText: 2,
          shadowText: 0,
          shadowTextColor: "#000000",
          textColor: "#ffa047FF",
          textColorBackground: "#00000080"
        },
        {
          // rumen na vijolični
          fontText: 6,
          shadowText: 7,
          shadowTextColor: "#000000",
          textColor: "#f2d51cFF",
          textColorBackground: "#91036bFF"
        },
        {
          // bel tekst, brez ozadja, roza obroba
          fontText: 3,
          shadowText: 20,
          shadowTextColor: "#c80494",
          textColor: "#FFFFFFFF",
          textColorBackground: "#00000000"
        },
        {
          // bela na zeleni podlagi
          fontText: 1,
          shadowText: 0,
          shadowTextColor: "#000000",
          textColor: "#FFFFFFFF",
          textColorBackground: "#20be04FF"
        },
        {
          // moder tekst, brez ozadja, pisane črke
          fontText: 7,
          shadowText: 0,
          shadowTextColor: "#ffffff",
          textColor: "#0470c8FF",
          textColorBackground: "#00000000"
        },
        {
          // default
          fontText: 1,
          shadowText: 0,
          shadowTextColor: "#000000",
          textColor: "#0000A0FF",
          textColorBackground: "#FFFFFF00"
        },
        {
          // bel tekst s črno obrobo
          fontText: 0,
          shadowText: 12,
          shadowTextColor: "#000000",
          textColor: "#FFFFFFFF",
          textColorBackground: "#00000000"
        }
      ],
      textBrush: {
        // bel tekst s črno obrobo
        fontText: 0,
        shadowText: 12,
        shadowTextColor: "#000000",
        textColor: "#FFFFFFFF",
        textColorBackground: "#00000000"
      },
      simpleFrameBorderSettings: {
        borderWidth: 20,
        borderColor: "#FFFFFFFF",
        borderRadius: 0
      },
      templateItemExtraSettings: {
        textFunction: 0,
        allowDelete: false,
        allowManipulate: false,
        allowEdit: false,
        allowReplace: "",
      },
      giftCardTemplateValidItems: [
        {
          title: this.$t("settingsGiftCardTemplateValidMonth"),
          days: 30,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidTwoMonths"),
          days: 60,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidThreeMonths"),
          days: 90,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidSixMonths"),
          days: 180,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidYear"),
          days: 365,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidTwoYears"),
          days: 730,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidThreeYears"),
          days: 1100,
        },
        {
          title: this.$t("settingsGiftCardTemplateValidInfinite"),
          days: -1,
        }
      ],
      toggleFilterItems: [
        {
          title: this.$t("userOrdersDateViewLast7"),
          days: 7,
        },
        {
          title: this.$t("userOrdersDateViewLast30"),
          days: 30,
        },
        {
          title: this.$t("userOrdersDateViewLast90"),
          days: 90,
        },
      ],
      countryItems: [
        {
          title: this.$t("cSloveniaName"),
          cShort: "si",
        },
        {
          title: this.$t("cCroatiaName"),
          cShort: "hr",
        },
      ],
      orderType: [
        {
          title: this.$t("dialogImageDatabaseSelectionOrderByPopularity"),
          query: "popular"
        },
        {
          title: this.$t("dialogImageDatabaseSelectionOrderByAddition"),
          query: "add"
        }
      ],
      monthsType: [
        {
          title: this.$t("monthJanuary"),
          query: 0
        },
        {
          title: this.$t("monthFebruary"),
          query: 1
        },
        {
          title: this.$t("monthMarch"),
          query: 2
        },
        {
          title: this.$t("monthApril"),
          query: 3
        },
        {
          title: this.$t("monthMay"),
          query: 4
        },
        {
          title: this.$t("monthJune"),
          query: 5
        },
        {
          title: this.$t("monthJuly"),
          query: 6
        },
        {
          title: this.$t("monthAugust"),
          query: 7
        },
        {
          title: this.$t("monthSeptember"),
          query: 8
        },
        {
          title: this.$t("monthOctober"),
          query: 9
        },
        {
          title: this.$t("monthNovember"),
          query: 10
        },
        {
          title: this.$t("monthDecember"),
          query: 11
        },
      ],
      numberFormatItems: [
        {
          title: this.$t("cSloveniaName"),
          nfShort: "sl",
        },
        {
          title: this.$t("cCroatiaName"),
          nfShort: "hr",
        },
      ],
      qrCodeFormatItems: [
        {
          title: this.$t("cSloveniaName"),
          qrShort: "sl",
        },
        {
          title: this.$t("cCroatiaName"),
          qrShort: "hr",
        },
      ],
      themeSelect: [
        {
          theme: this.$t("settingsOtherThemeLightTitle"),
          type: "light",
        },
        {
          theme: this.$t("settingsOtherThemeDarkTitle"),
          type: "dark",
        },
      ],
      giftSuperType: [
        {
          name: this.$t("settingsPhotoGiftSuperTypeItemTitle"),
          type: 0,
        },
        {
          name: this.$t("settingsPhotoGiftSuperTypeGiftTitle"),
          type: 1,
        },
        {
          name: this.$t("settingsPhotoGiftSuperTypeCollageTitle"),
          type: 2,
        },
        {
          name: this.$t("settingsPhotoGiftSuperTypeCustomTitle"),
          type: 3,
        },
        {
          name: this.$t("settingsPhotoGiftSuperTypeGiftCardTitle"),
          type: 4,
        },
        {
          name: this.$t("settingsPhotoGiftSuperTypeLargePrintTitle"),
          type: 5,
        },
        {
          name: this.$t("settingsPhotoGiftSuperTypePhotoCanvasTitle"),
          type: 6,
        },
      ],
      currencyItems: [
        {
          title: "EUR",
        },
        {
          title: "HRK",
        },
      ],
      discountTypeItems: [
        {
          name: this.$t("settingsPromoCodesDiscountedTypePct"),
          value: "Pct",
        },
        {
          name: this.$t("settingsPromoCodesDiscountedTypeAmt"),
          value: "Amt"
        },
      ],
      moduleItems: [
        {
          name: this.$t("settingsSubMenuModulePhotoOrderTitle"),
          module: constants.G_MODULE_PHOTO_ORDER,
        },
        {
          name: this.$t("settingsSubMenuModulePhotoGiftTitle"),
          module: constants.G_MODULE_PHOTO_GIFT,
        },
      ],
      deliveryTypeItems: [
        {
          title: this.$t("userCashierDeliveryTypeAtDeliveryTitle"),
          type: "atDelivery",
        },
        {
          title: this.$t("userCashierDeliveryTypePersonalTitle"),
          type: "personal",
        },
        {
          title: this.$t("userCashierDeliveryTypePrepayTitle"),
          type: "prepay",
        },
        {
          title: this.$t("userCashierDeliveryTypeCardTitle"),
          type: "creditCard",
        },
      ],
      // form validation rules
      validateRequired() {
        return (v) => !!v || this.$t("frmValidationRequiredField");
      },
      validateIsPercent() {
        return (v) =>
          /^[0-9]{1,3}$/.test(v) || this.$t("frmValidationNotPctField");
      },
      validateMaxLength(maxLength) {
        return (v) =>
          v.length <= maxLength || this.$t("frmValidationStringTooLongField");
      },
      validateNumberLimit(num) {
        return (v) =>
          v <= num || this.$t("frmValidationNumberTooBigField");
      },
      validateIsCurrency() {
        return (v) =>
          /^([0-9]+(\.[0-9]+)?)$/.test(v) ||
          this.$t("frmValidationNotCurrencyField");
      },
      validateIsEmail() {
        return (v) =>
          /.+@.+/.test(v) || v.length == 0 || this.$t("lmFrmErrorFormatField");
      },
      validatePassword() {
        return (v) => v.length >= 5 || this.$t("lmFrmErrorFormatPasswordField");
      },
      validateIsNumber() {
        return (v) => !isNaN(v) || this.$t("frmValidationNotNumberField");
      },
      price(price) {
        return Intl.NumberFormat(
          this.$store.state.storeClient.client.environmentSettings.numberFormat,
          {
            style: "currency",
            currency: this.$store.state.storeClient.client.environmentSettings
              .currency,
            minimumFractionDigits: this.$store.state.storeClient.client
              .environmentSettings.digits,
          }
        ).format(price);
      },
      percent(price) {
        return Intl.NumberFormat(
          this.$store.state.storeClient.client.environmentSettings.numberFormat,
          {
            style: "percent",
            minimumFractionDigits: 0,
          }
        ).format(price / 100);
      },
      getTheme() {
        return this.$store.state.storeClient.client.visualSettings.themeColor
          .type;
      },
      timePassedSinceAddRaw(seconds) {
        let nowSeconds = parseInt(moment().unix() - seconds); //because moment js dont know to handle number in string format        
        return nowSeconds
      },
      timePassedSinceAdd(seconds) {
        let nowSeconds = parseInt(moment().unix() - seconds); //because moment js dont know to handle number in string format
        if (nowSeconds < 60 || isNaN(nowSeconds)) {
          return this.$t("fHowLongAgoNow");
        } else if (nowSeconds < 180) {
          return this.$t("fHowLongAgoFewMinutes");
        } else if (nowSeconds < 3600) {
          return (
            this.$t("fHowLongAgoPrefix") +
            moment.duration(nowSeconds, "seconds").format("m") +
            this.$t("fHowLongAgoMinSufix")
          );
        } else if (nowSeconds < 10800) {
          return this.$t("fHowLongAgoFewHours");
        } else if (nowSeconds < 86400) {
          return (
            this.$t("fHowLongAgoPrefix") +
            moment.duration(nowSeconds, "seconds").format("h") +
            this.$t("fHowLongAgoHourSufix")
          );
        } else if (nowSeconds < 172800) {
          return this.$t("fHowLongAgoYesterday");
        } else if (nowSeconds < 259200) {
          return this.$t("fHowLongAgoFewDays");
        } else
          return (
            this.$t("fHowLongAgoPrefix") +
            moment.duration(nowSeconds, "seconds").format("d") +
            this.$t("fHowLongAgoDaySufix")
          );
      },
      daysLeftSince(item) {
        let seconds = parseInt(item - moment().unix()); //because moment js dont know to handle number in string format
        if (moment.duration(seconds, "seconds").format("d") > 0) {
          return (
            moment.duration(seconds, "seconds").format("d") +
            " " +
            this.$t("lmDays")
          );
        } else return this.$t("lmLastDay");
      },
      getModuleName(name) {
        if (name == constants.G_MODULE_ALL) {
          return this.$t("settingsSubMenuAllTitle");
        } else if (name == constants.G_MODULE_PHOTO_ORDER) {
          return this.$t("settingsSubMenuModulePhotoOrderTitle");
        } else if (name == constants.G_MODULE_PHOTO_GIFT) {
          return this.$t("settingsSubMenuModulePhotoGiftTitle");
        }
      },
      getImageDatabaseName(name, category) {
        if (category) {
          console.log(name)
          if (name == constants.G_IMAGE_DATABASE_TYPE_BACKGROUNDS) {
            return this.$t("dashboardCardSuperAdminBackgroundsCatDatabase");
          } else if (name == constants.G_IMAGE_DATABASE_TYPE_PATTERNS) {
            return this.$t("dashboardCardSuperAdminPatternsCatDatabase");
          } else if (name == constants.G_IMAGE_DATABASE_TYPE_FRAMES) {
            return this.$t("dashboardCardSuperAdminFramesCatDatabase");
          } else if (name == constants.G_IMAGE_DATABASE_TYPE_STICKERS) {
            return this.$t("dashboardCardSuperAdminStickersCatDatabase");
          }
        } else {
          if (name == constants.G_IMAGE_DATABASE_TYPE_BACKGROUNDS) {
            return this.$t("dashboardCardSuperAdminBackgroundsDatabase");
          } else if (name == constants.G_IMAGE_DATABASE_TYPE_PATTERNS) {
            return this.$t("dashboardCardSuperAdminPatternsDatabase");
          } else if (name == constants.G_IMAGE_DATABASE_TYPE_FRAMES) {
            return this.$t("dashboardCardSuperAdminFramesDatabase");
          } else if (name == constants.G_IMAGE_DATABASE_TYPE_STICKERS) {
            return this.$t("dashboardCardSuperAdminStickersDatabase");
          }
        }
      },
      getImageDatabaseIcon(name) {
        if (name == constants.G_IMAGE_DATABASE_TYPE_BACKGROUNDS) {
          return "mdi-image";
        } else if (name == constants.G_IMAGE_DATABASE_TYPE_PATTERNS) {
          return "mdi-dots-grid";
        } else if (name == constants.G_IMAGE_DATABASE_TYPE_FRAMES) {
          return "mdi-border-outside";
        } else if (name == constants.G_IMAGE_DATABASE_TYPE_STICKERS) {
          return "mdi-sticker-emoji";
        }
      },
    };
  },
});

// najprej moramo pridobiti ime klienta (foto studia) iz URL-ja in
// ga poiskati v bazi, če obstaja
let tempClient = window.location.pathname.replace(/\//g, "");
if (tempClient == "") {
  tempClient = window.location.hostname.split(".")[0];
}
store.dispatch("getClient", tempClient).then(() => {
  let opts = {};

  if (VueCookies.isKey("client")) {
    store.dispatch("getClient", VueCookies.get("client")).then(() => {
      //console.log(store.state.storeClient.client);
      // set colors from database
      opts = {
        iconfont: "mdi",
        customProperties: true,
        theme: {
          themes: {
            light: {
              primary:
                store.state.storeClient.client.visualSettings.themeColor
                  .primaryColor,
              secondary:
                store.state.storeClient.client.visualSettings.themeColor
                  .secondaryColor,
              accent:
                store.state.storeClient.client.visualSettings.themeColor
                  .accentColor,
            },
          },
        },
      };

      // set language
      if (VueCookies.isKey("lang")) {
        Vue.i18n.set(VueCookies.get("lang"));
        VueCookies.set("lang", VueCookies.get("lang"));
      } else {
        if (store.state.storeClient.client.environmentSettings.lang) {
          Vue.i18n.set(store.state.storeClient.client.environmentSettings.lang);
          VueCookies.set(
            "lang",
            store.state.storeClient.client.environmentSettings.lang
          );
        } else {
          Vue.i18n.set("en");
        }
      }

      let app = "";
      firebase.auth().onAuthStateChanged((user) => {
        // console.log(user);
        if (user) {
          store.commit("setUser", user);
          store.commit("setIsAuthenticated", true);
          store.dispatch("fetchUserProfile", user).then(() => {
            store.dispatch("setUserStats", {
              uid: user.uid, client: store.state.storeClient.client.basicSettings.name, email: user.email, orders: 0, ordersSum: 0,
              timestamp: new Date(Date.now())
            });
            // preverimo ali je dovoljeno pošiljanje FCM sporočil
            // če je, pridobimo token in ga po potrebi shranimo v bazo
            if (store.state.storeAuth.userProfile.allowFCMOrderNotification) {
              store.dispatch("setFCMAllow", true);
            }
            // load all store start data depending on the user and app rights
            if (store.state.storeAuth.userProfile.isAdmin) {
              store.dispatch("getOrderPackages", {
                client: store.state.storeClient.client.basicSettings.name,
                isAdminShowPackages:
                  store.state.storeAuth.userProfile.isAdminShowPackages,
                statusFrom: 0,
                statusTo: 2,
              });
            }
            // load all store start data depending on the user and app rights
            if (store.state.storeAuth.userProfile.isSuperStoreAdmin) {
              store.dispatch("getClients");
            }
            if (
              (store.state.storeAuth.userProfile.isSuperAdmin &&
                store.state.storeAuth.userProfile.client ==
                store.state.storeClient.client.basicSettings.name) ||
              store.state.storeAuth.userProfile.isSuperStoreAdmin
            ) {
              store.dispatch("getCartWaiting", {
                client: store.state.storeClient.client.basicSettings.name,
              });
              store.dispatch("getOrderDay", {
                client: store.state.storeClient.client.basicSettings.name,
              });
              store.dispatch("getOrderMonth", {
                client: store.state.storeClient.client.basicSettings.name,
              });
              store.dispatch("getOrderLast7Days", {
                client: store.state.storeClient.client.basicSettings.name,
              });
            }
            if (
              store.state.storeClient.client.modules.modulePhotoOrder.active
            ) {
              store.dispatch(
                "getImageSize",
                store.state.storeClient.client.basicSettings.name
              );
              store.dispatch(
                "getImageDiscount",
                store.state.storeClient.client.basicSettings.name
              );
              store.dispatch(
                "getPaperType",
                store.state.storeClient.client.basicSettings.name
              );
            }
            if (
              store.state.storeClient.client.modules.modulePhotoOrder.active
            ) {
              store.dispatch("getGiftSuperCategory", {
                client: store.state.storeClient.client.basicSettings.name,
                mode: "live",
              });
            }
            store.dispatch("getModeratorOnline", {
              client: store.state.storeClient.client.basicSettings.name,
              uid: store.state.storeAuth.user.uid,
            });
            store.dispatch("getRoom", {
              client: store.state.storeClient.client.basicSettings.name,
              uid: store.state.storeAuth.user.uid,
            });
            store.dispatch(
              "getPromoCodes",
              store.state.storeClient.client.basicSettings.name
            );
            store.dispatch(
              "getDelivery",
              store.state.storeClient.client.basicSettings.name
            );
            store.dispatch("getCartItems", {
              client: store.state.storeClient.client.basicSettings.name,
              uid: store.state.storeAuth.user.uid,
              status: 0,
            });
            store.dispatch("getOrderItems", {
              client: store.state.storeClient.client.basicSettings.name,
              uid: store.state.storeAuth.user.uid,
              days: 30,
            });
          });
        } else {
          store.commit("setUser", {});
          store.commit("setIsAuthenticated", false);
          store.commit("setUserProfile", {});
        }
        if (!app) {
          const vuetify = new Vuetify(opts);

          Vue.use(TiptapVuetifyPlugin, {
            // the next line is important! You need to provide the Vuetify Object to this place.
            vuetify, // same as "vuetify: vuetify"
            // optional, default to 'md' (default vuetify icons before v2.0.0)
            iconsGroup: "mdi",
          });

          new Vue({
            router,
            store,
            vuexI18n,
            vuetify: vuetify,
            render: (h) => h(App),
          }).$mount("#app");
        }
      });
    });
  } else {
    // če trgovina ni najdena
    const vuetify = new Vuetify(opts);
    Vue.use(TiptapVuetifyPlugin, {
      // the next line is important! You need to provide the Vuetify Object to this place.
      vuetify, // same as "vuetify: vuetify"
      // optional, default to 'md' (default vuetify icons before v2.0.0)
      iconsGroup: "mdi",
    });

    new Vue({
      router,
      store,
      vuexI18n,
      vuetify: vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
